import { z } from "zod";
//
// Read
//
export const DTOAccessToken = z.object({
    id: z.string(),
    createdAt: z.coerce.date(),
    name: z.string(),
    scope: z.string().optional(),
});
export const DTOAccessTokenFull = DTOAccessToken.extend({
    token: z.string(),
});
export const DTOAccessTokenListResponse = z.object({
    tokens: DTOAccessToken.array(),
});
export const DTOAccessTokenResponse = z.object({
    token: DTOAccessToken,
});
export const DTOAccessTokenFullResponse = z.object({
    token: DTOAccessTokenFull,
});
//
// Write
//
export const DTOAccessTokenCreatePayload = z.object({
    name: z.string(),
    scope: z.string().optional(),
});
